export const certificateData = {
    title: "Think in a Redux Way",
    platform: "Learn with Sumit",

    tag: [
        "Redux",
        "Redux Toolkit",
        "RTK Query",
        "Redux Thunk",
        "Reselect",
        "React.js",
    ],

    feedback:
        "Successfully completed the 'Think in a Redux Way' course from Learn with Sumit with an outstanding final score of 96%. Gained hands-on experience in Redux, Redux Toolkit, RTK Query, Redux Thunk, Reselect, and advanced state management techniques by completing practical assignments, quizzes, and the final assessment.",

    courseCertificate: require("../assets/images/certification/LWS-Certificate.png"),
    courseReport: require("../assets/images/certification/LWS-Report-Card.png"),
    recommendation: require("../assets/images/certification/LWS-Recommendation-Letter.png"),
};